import { tw } from 'twind';
import { useCartStore } from 'store/cart';

const format = (currency: string, amount: number) => new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(amount / 100);

export const Price: React.FC<{price?: { currency: string; amount: number; old_amount?: number | null } | null }> = ({ price }) => {
  const { theme } = useCartStore();
  
  if (!price) {
    return <span>-</span>;
  }

  const output = format(price.currency, price.amount);
  const previously = price.old_amount && price.old_amount !== price.amount ? <del>{format(price.currency, price.old_amount)}</del> : null;

  return (
    <span className={`text-${theme}-primary`}>
      {previously} {output}
    </span>
  );
};
